import React, { Component } from 'react';
import styles from "../styles/home.module.scss";



class Support extends Component {
    state = { 
        title:"Support us",
     } 
    styles={
        textAlign:"center",
        marginTop:"2rem",
        fontSize:"3rem",
    }
    render() { 
        return (
            <div className={styles["support-container"]}>
                <h1 style={this.styles}>{this.state.title}</h1>
                <div className={styles["content"]}>
                    <h2>We currently have no sponsor</h2>
                    <p>Hey! there be the first to sponsor us</p>
                    <button className={styles["button"]}>Click here</button>
                </div>
            </div>
        );
    }
}
 
export default Support;